import { formatAppDate } from '../../hooks/utils';
import { DATE_FORMAT } from '../../constants';

export function GroupHeader(props: any) {
  let result;
  let isDate = false;
  try {
    result = formatAppDate(props.dataItem?.key, DATE_FORMAT);

    isDate = true;
  } catch (e) {
    result = props.children;
  }
  return (
    <>
      {props.tdProps && (
        <td {...props.tdProps} key={props.tdProps.key} ref={props.tdProps.ref}>
          {props.children && (
            <p className="k-reset">
              {' '}
              {isDate && props.children.props.children[0]}
              {result}
            </p>
          )}
        </td>
      )}
    </>
  );
}
